import { render } from "./Login_Register.vue?vue&type=template&id=94a5160c&scoped=true"
import script from "./Login_Register.vue?vue&type=script&lang=js"
export * from "./Login_Register.vue?vue&type=script&lang=js"

import "./Login_Register.vue?vue&type=style&index=0&id=94a5160c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94a5160c"]])

export default __exports__